export class OvertimeReportPeriodsRequest {
    all : boolean;
    beginPeriod : string;
    departmentId : number;
    employeeId : number;
    endPeriod : string;
    reportType : string;
    exportType: string;
    projectCode: string;
    tenantCode: string;
    isRestDay: number;
    isEmployeeReport : number;
}
